<!-- Contenedor mensaje confirmación -->
<p-toast></p-toast>
<!-- Fin mensaje confirmación -->

<!-- Modal postulación -->
<p-dialog  [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '95vw'}" [style]="{width: '40vw'}" [(visible)]="display">  
  <ng-template pTemplate="header">
    Es necesario confirmar la acción
  </ng-template>
  <p>Al presionar el botón, se enviarán tus datos para la postulación. Luego podrás revisar el estado de la postulación desde tu cuenta y acceder a los contenidos del curso. </p>
  <p><b>Información postulante:</b></p>
  <table>
    <tr>
      <td><b>Nombre</b></td>
      <td>{{postulante.nombres}} {{postulante.paterno}}</td>
    </tr>
    <tr>
      <td><b>Run</b></td>
      <td>{{postulante.run}}-{{postulante.dv}}</td>
    </tr>
    <tr>
      <td><b>Correo</b></td>
      <td>{{postulante.correo}}</td>
    </tr>
  </table>
  <div *ngIf="preguntasPostulacion.length" class="p-mt-3">
    <p-dropdown [disabled]="loading" appendTo="body" placeholder="Cuentanos como conociste el curso" [autoDisplayFirst]="false" [options]="preguntasPostulacion" [(ngModel)]="preguntaCurso" optionLabel="label" optionValue="value"></p-dropdown>
  </div>
  <p>¿Confirma postulación al curso? (Se enviará una copia a tu correo electrónico).</p>
  <p-footer>
    <button 
      pButton 
      icon="pi pi-times" 
      (click)="toggleDialog()" 
      label="Cancelar"
      class="p-mt-2 btn-default"
    ></button>
    <button 
      pButton 
      icon="pi pi-check" 
      (click)="postular()" 
      [loading]="loading"
      [disabled]="loading || (preguntasPostulacion.length && !preguntaCurso)"
      [label]="loading ? 'Postulando, espere...' : 'Aceptar'"
      class="p-mt-2 btn-primary"
    ></button>
  </p-footer>
</p-dialog>
<!-- Fin modal postulación-->

<!-- Botón postular ahora -->
<button 
  pButton 
  type="button" 
  (click)="toggleDialog()" 
  icon="pi pi-check-circle" 
  label="Postula ahora al curso"
  class="p-mt-2 btn-primary"
></button>
<!-- Fin botón postular ahora -->